import * as ToggleMenuFlyoutEvent from '@ori-events/toggle-menu-flyout';

export const openLoginSidebar = () => {
  window.dispatchEvent(
    new CustomEvent<ToggleMenuFlyoutEvent.Data>(ToggleMenuFlyoutEvent.Name, {
      detail: { menuType: ToggleMenuFlyoutEvent.MenuTypes.AccountSideMenu },
    }),
  );
};
